document.addEventListener('DOMContentLoaded', function () {
  initializeEngraveFeature();
});
// Reinitialize Engrave Feature after the section is re-rendered
document.addEventListener('section:load', function () {
  initializeEngraveFeature();
});

const INPUT_REGEX = /[\x20-\x7E\xA0-\xFF]/;

function initializeEngraveFeature() {
  const accordionToggles = document.querySelectorAll('.accordion-toggle');
  const addToCartButtons = document.querySelectorAll('.product-form__submit');

  const cardHeader = document.getElementById('card-header');

  accordionToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const target = this.getAttribute('aria-controls');
      const content = document.getElementById(target);

      if (content.classList.contains('active')) {
        content.classList.remove('active');
        this.setAttribute('aria-expanded', 'false');
        cardHeader.innerHTML = addEngraveLabel;
        removeLines();
      } else {
        content.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
        cardHeader.innerHTML = removeEngraveLabel;
        updateLines(1);
      }
    });
  });

  const tabs = document.querySelectorAll('.tab');
  const inputsContainer = document.querySelector('.product-form__engraving-input');
  const defaultFontLine = document.getElementById('fontLineAttribute');
  const casebackTextsDiv = document.querySelector('.product-gallery__caseback-texts');

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      tabs.forEach((otherTab) => {
        if (otherTab !== tab) {
          otherTab.classList.remove('active');
        }
      });
      this.classList.add('active');
      const line = parseInt(this.getAttribute('data-line'));
      updateLines(line);
    });
  });

  function removeLines() {
    inputsContainer.innerHTML = '';
    defaultFontLine.innerHTML = '';
    engraveAdditionalInfo.innerHTML = '';
    addToCartButtons.forEach((btn) => (btn.disabled = false));
  }

  function updateLines(numLines) {
    var currentLines = inputsContainer.querySelectorAll('div').length;
    currentLines++;
    if (currentLines > numLines) {
      var divsToRemove = inputsContainer.querySelectorAll('div').length - numLines;
      // Select and remove the excess div elements
      for (var i = 0; i < divsToRemove; i++) {
        inputsContainer.removeChild(inputsContainer.lastElementChild);
      }
    }

    for (let i = currentLines; i <= numLines; i++) {
      const label = document.createElement('label');
      label.setAttribute('for', `Line_${i}`);
      label.classList.add('product-form__engraving-input-legend', 'product-form__engraving-input-legend-top');
      label.textContent = `Line ${i}`;

      const input = document.createElement('input');
      input.setAttribute('id', `Line_${i}`);
      input.setAttribute('name', `properties[personalization_line${i}]`);
      input.setAttribute('type', 'text');
      input.setAttribute('form', product_form_id);
      input.setAttribute('placeholder', `Line ${i} Text`);
      input.setAttribute('maxlength', '22');
      input.setAttribute('aria-label', 'Maximum 22 characters allowed');
      input.classList.add('form-control');

      // Attach keypress event listener to each input field
      input.addEventListener('change', function () {
        displayTexts();
        validateEngraving();
      });

      input.addEventListener('input', function () {
        displayTexts();
        validateEngraving();
      });

      const span = document.createElement('span');
      const textLength = document.createElement('span');
      if (i === 1) {
        span.classList.add('engravingTooltip');
        span.innerHTML = infoIcon;

        const toolTip = document.createElement('span');
        toolTip.innerHTML = engrave_tooltip;
        toolTip.classList.add('tooltip-content');
        span.appendChild(toolTip);

        span.addEventListener('click', function () {
          // Toggle display of tooltip content on click
          const tooltipContent = this.querySelector('.tooltip-content');
          tooltipContent.style.display = tooltipContent.style.display === 'block' ? 'none' : 'block';
        });

        textLength.textContent = '22 character max';
        textLength.classList.add('product-form__engraving-input-legend', 'product-form__engraving-input-legend-bottom');
      }

      const lineError = document.createElement('span');
      lineError.textContent = 'You have entered an invalid character(s)';
      lineError.classList.add('product-form__engraving-input-error');

      const lineContainer = document.createElement('div');
      lineContainer.appendChild(label);
      lineContainer.appendChild(input);
      lineContainer.appendChild(lineError);
      if (i === 1) {
        lineContainer.appendChild(span);
        lineContainer.appendChild(textLength);
      }

      inputsContainer.appendChild(lineContainer);
    }

    const defaultFont = document.getElementById('font-MODERN');
    defaultFont.click();

    addToCartButtons.forEach((btn) => (btn.disabled = true));

    displayTexts();
    validateEngraving();
  }

  function displayTexts() {
    // Get all input values and concatenate them
    const inputs = document.querySelectorAll('.product-form__engraving-input input');
    let text = '';

    inputs.forEach(function (input) {
      // Filter the input value to include only characters matching the regex
      const sanitizedValue = Array.from(input.value)
        .filter((char) => INPUT_REGEX.test(char))
        .join('');

      text += '<span>' + sanitizedValue + '</span>';
    });

    // Update the content of the span with the concatenated text
    casebackTextsDiv.innerHTML = text;
  }

  function validateEngraving() {
    // Get all input values and concatenate them
    const inputs = document.querySelectorAll('.product-form__engraving-input input');
    var hasError = false;
    inputs.forEach(function (input) {
      var inputValue = input.value;
      var errorMessageSpan = input.nextElementSibling;
      for (let i = 0; i < inputValue.length; i++) {
        var key = inputValue[i];
        if (!INPUT_REGEX.test(key)) {
          input.parentElement.classList.add('error');
          errorMessageSpan.style.display = 'block';
          hasError = true;
          break;
        } else {
          input.parentElement.classList.remove('error');
          errorMessageSpan.style.display = 'none';
        }
      }

      if (input.value === '' || input.value === null) {
        hasError = true;
      }
    });

    if (hasError) {
      addToCartButtons.forEach((btn) => (btn.disabled = true));
    } else {
      addToCartButtons.forEach((btn) => (btn.disabled = false));
    }
  }

  // Add click event to the surrounding div
  document.querySelectorAll('.engrave-font').forEach(function (engraveFontDiv) {
    engraveFontDiv.addEventListener('click', function () {
      const radioButton = engraveFontDiv.querySelector('input[type="radio"]');
      if (radioButton) {
        radioButton.checked = true; // Check the radio button
        radioButton.dispatchEvent(new Event('click')); // Trigger the change event if needed
      }
    });
  });

  // Get all radio buttons within the specified class
  const radioButtons = document.querySelectorAll('.product-form__engraving-input-fonts__selector input[type="radio"]');
  const casebackTexts = document.querySelector('.product-gallery__caseback-texts');
  const fontLineAttribute = document.getElementById('fontLineAttribute');
  const engraveAdditionalInfo = document.getElementById('engraveAdditionalInfo');

  // Helper function to create hidden input fields
  function createHiddenInput(name, value, formId) {
    const input = document.createElement('input');
    input.setAttribute('name', `properties[${name}]`);
    input.setAttribute('type', 'hidden');
    input.setAttribute('form', formId);
    input.setAttribute('value', value);
    return input;
  }

  // Add click event listener to each radio button
  radioButtons.forEach(function (radioButton) {
    radioButton.addEventListener('click', function () {
      // Get the value of the clicked radio button
      const selectedFont = this.value;
      const engravingData = engravingJson[selectedFont] || engravingJson.DEFAULT;
      const engraveSize = engravingData.engraving_size;
      const fontSize = engravingData.size;

      // Apply styles to casebackTexts
      if (casebackTexts) {
        casebackTexts.style.fontFamily = selectedFont;
        casebackTexts.style.fontSize = fontSize;
        casebackTexts.style.color = window.engravingTextColor;
      }

      // Clear previous attributes before appending new ones
      fontLineAttribute.innerHTML = '';

      // Create and append necessary hidden inputs
      fontLineAttribute.appendChild(createHiddenInput('font_style', selectedFont, product_form_id));
      fontLineAttribute.appendChild(createHiddenInput('font_size', engraveSize, product_form_id));

      engraveAdditionalInfo.innerHTML = '';
      engraveAdditionalInfo.appendChild(createHiddenInput('engraving_fee', engravePrice, product_form_id));
      engraveAdditionalInfo.appendChild(createHiddenInput('_LPROP', 'Final Sale', product_form_id));

      // Add timestamp
      const engravingDate = new Date();
      const timeStamp = engravingDate.toISOString();
      engraveAdditionalInfo.appendChild(createHiddenInput('_time_stamp', timeStamp, product_form_id));

      // Generate engraving_id and add as hidden input
      const engravingId = `${engravingDate.getTime()}${selectedFont.length}${engraveSize.length}`;
      engraveAdditionalInfo.appendChild(createHiddenInput('_engraving_id', engravingId, product_form_id));
    });
  });
}
